import Controller from '@ember/controller';

export default class PublicPostController extends Controller {
  queryParams = ['groupId', 'eventId', 'ppId'];
  groupId = null;
  eventId = null;
  ppId = null; // public page link, publicLinkId
}
